export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "科技数码",
    slug: "tech",
    description: "最新科技资讯、数码产品评测、行业趋势分析",
    icon: "ri-smartphone-line",
    articleCount: 128,
  },
  {
    id: "cat-2",
    name: "生活娱乐",
    slug: "lifestyle",
    description: "美食旅行、时尚穿搭、家居生活、娱乐八卦",
    icon: "ri-heart-line",
    articleCount: 256,
  },
  {
    id: "cat-3",
    name: "学习教育",
    slug: "education",
    description: "在线课程、考试攻略、职业技能、知识科普",
    icon: "ri-book-open-line",
    articleCount: 189,
  },
  {
    id: "cat-4",
    name: "游戏动漫",
    slug: "gaming",
    description: "热门游戏攻略、动漫资讯、电竞比赛、二次元文化",
    icon: "ri-gamepad-line",
    articleCount: 312,
  },
  {
    id: "cat-5",
    name: "影视音乐",
    slug: "entertainment",
    description: "电影推荐、剧集点评、音乐分享、娱乐圈动态",
    icon: "ri-movie-2-line",
    articleCount: 203,
  },
  {
    id: "cat-6",
    name: "健康养生",
    slug: "health",
    description: "科学健身、营养饮食、心理健康、养生知识",
    icon: "ri-heart-pulse-line",
    articleCount: 145,
  },
];